import BillDetailModel from 'models/payments/BillDetailModel';
import { createSelector } from 'reselect';
import { ACCOUNTS_REDUCER } from 'store/redux/accounts/reducer';

const _selectUserBills = (state) => state[ACCOUNTS_REDUCER].bills;
const _selectCurrentBill = (state) => state[ACCOUNTS_REDUCER].currentBill;
const _selectUserBalances = (state) => state[ACCOUNTS_REDUCER].balances;
const _selectUserBalancesByMonth = (state) =>
  state[ACCOUNTS_REDUCER].balancesByMonth;
const _selectUserBalancesUnderReview = (state) =>
  state[ACCOUNTS_REDUCER].balancesUnderReview;
const _selectUserBalancesPastMonths = (state) =>
  state[ACCOUNTS_REDUCER].balancesPastMonths;
const _selectSimulatePayments = (state) =>
  state[ACCOUNTS_REDUCER].splitPayments;
const _selectFinancePlanDetails = (state) =>
  state[ACCOUNTS_REDUCER].financePlan;
const _selectFinancePlanPayments = (state) =>
  state[ACCOUNTS_REDUCER].financePlanPayments;

export const selectBills = createSelector(_selectUserBills, (bills) =>
  bills?.items ? bills?.items.map((bill) => new BillDetailModel(bill)) : [],
);
export const selectCurrentBill = createSelector(
  _selectCurrentBill,
  (payment) => new BillDetailModel(payment),
);
export const selectBalances = createSelector(
  _selectUserBalances,
  (balances) => balances,
);
export const selectBalancesUnderReview = createSelector(
  _selectUserBalancesUnderReview,
  (balances) => balances,
);
export const selectBalancesByMonth = createSelector(
  _selectUserBalancesByMonth,
  (balances) => balances?.reverse(),
);
export const selectBalancesPastMonths = createSelector(
  _selectUserBalancesPastMonths,
  (balances) => balances,
);

export const selectSimulatePayments = createSelector(
  _selectSimulatePayments,
  (simulation) => simulation || {},
);

export const selectFinancePlanDetails = createSelector(
  _selectFinancePlanDetails,
  (financePlan) => financePlan || {},
);
export const selectFinancePlanPayments = createSelector(
  _selectFinancePlanPayments,
  (financePlanPayments) => financePlanPayments || {},
);
